import styled from 'styled-components'
import { useMemo } from 'use-memo-one'

import { AppDataTable } from '@root/features/app-data-table/app-data-table'

import { reatomUserProfileHoldingsAssetsTable } from '../../atoms/reatom-user-profile-holdings-assets-table'

import type { HoldingsAssetsColumnId } from './holdings-assets-table-columns'
import type { UserProfileHoldingsWalletAsset } from '../../model/user-profile-holdings-wallet-asset'

export const HOLDINGS_ASSETS_TABLE_ROW_HEIGHT = 38
export const HOLDINGS_ASSETS_TABLE_HEADER_HEIGHT = 32

type Props = {
  assets: ReadonlyArray<UserProfileHoldingsWalletAsset>
}

export const HoldingsAssetsTable: React.FC<Props> = ({ assets }) => {
  const model = useMemo(
    // eslint-disable-next-line @reatom/unit-naming-rule
    () => reatomUserProfileHoldingsAssetsTable({ assets }),
    [assets],
  )

  return <Table model={model} rowHeight={HOLDINGS_ASSETS_TABLE_ROW_HEIGHT} />
}

const Table = styled(
  AppDataTable<UserProfileHoldingsWalletAsset, HoldingsAssetsColumnId>,
)`
  border-bottom: 1px solid var(--backgroundA-4);

  && {
    --data-table-header-bg: var(--appearance-1);
    --data-table-header-color: var(--textA-6);
    --data-table-header-color-hover: var(--textA-8);
    --data-table-row-border-color: var(--backgroundA-2);
    --data-table-row-even-bg: transparent;
    --data-table-row-odd-bg: transparent;
  }
  & *[data-table-header='true'] {
    border-bottom: 1px solid var(--background-2);
  }
`
